var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "trade-countdown",
      style: { width: `${Math.floor((_vm.value / 90) * 100)}%` },
    },
    [_c("strong", [_vm._v(_vm._s(_vm.value) + "s")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }